import { Component, OnChanges, OnInit, Inject, PLATFORM_ID, ElementRef, ViewChild } from '@angular/core';
import { ConceptResponseService } from '../../../services/concept_response.service';
import { ReportResponseService } from '../../../services/report_response.service';
import { ExpenseService } from '../../../services/expense.service';
import { ExpenseAttachmentsService } from '../../../../shared/services/expense_attachments.service';
import Swal from 'sweetalert2';
import { PeriodService } from '../../../../periods/period.service';
import { UserService } from '../../../../user/services/user.service';
import { isPlatformBrowser } from '@angular/common';
import { Modal } from 'bootstrap';

@Component({
  selector: 'app-list-concepts',
  templateUrl: './list-concepts.component.html',
  styleUrl: './list-concepts.component.scss'
})
export class ListConceptsComponent {
  @ViewChild('listAttachmentsModal') listAttachemntsModalRef!: ElementRef;
  @ViewChild('attachmentViewerModal') attachmentViewerModalRef!: ElementRef;
  modalInstance!: Modal;
  modalInstanceViewer!: Modal;

  concepts: any[] = [];
  attachments: any[] = [];
  selectedReportResponseId: string = ''; // 🔹 Nuevo campo para el reporte seleccionado
  isLoading: boolean = false;
  userRole: string = ''; // 🔹 Nuevo campo para el rol del usuario
  userCanEdit: boolean = false
  currentState: any = {}
  reportResponseData: any = {}
  constructor(
    @Inject(PLATFORM_ID) private platformId: any,
    private reportResponseService: ReportResponseService,
    private conceptResponseService: ConceptResponseService,
    private expenseService: ExpenseService,
    private expenseAttachmentsService: ExpenseAttachmentsService,
    private periodService: PeriodService,
    private userService: UserService,
  ) {
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      import('bootstrap').then(({ Modal }) => {
        if (this.listAttachemntsModalRef?.nativeElement) {
          this.modalInstance = new Modal(this.listAttachemntsModalRef.nativeElement);
        }

        if (this.attachmentViewerModalRef?.nativeElement) {
          this.modalInstanceViewer = new Modal(this.attachmentViewerModalRef.nativeElement);
        }
      });
    }
  }
  ngOnInit(): void {
    this.reportResponseService.selectedReportResponseId$.subscribe(reportResponseId => {
      if (reportResponseId) {
        this.cleanData();
        this.isLoading = false;
        this.selectedReportResponseId = reportResponseId;
        this.loadConceptResponses();
      }
    });

    /* this.periodService.selectedPeriodId$.subscribe(period => {
      if (period) {
        this.getReportResponse(period, this.userService.getselectedUserId())
      }
    }); */

    this.userService.userCanEdit$.subscribe(userCanEdit => {
      if (userCanEdit) {
        this.userCanEdit = userCanEdit
      }
    })

    this.userService.userRole$.subscribe(userRole => {
      if (userRole) {
        this.userRole = userRole
      }
    })

  }

  openListAttachmentsModal() {
    if (this.modalInstance && !this.listAttachemntsModalRef.nativeElement.classList.contains('show')) {
      this.modalInstance.show(); // Abre el modal solo si no está abierto
    }
  }

  closeListAttachmentsModal() {
    if (this.modalInstance) {
      this.modalInstance.hide(); // Cierra el modal
    }
  }

  openAttachmentViewerModal() {
    this.modalInstanceViewer?.show();
  }

  closeAttachmentViewerModal() {
    this.modalInstanceViewer?.hide();
  }

  cleanData() {
    this.concepts = [];
    this.attachments = [];
    this.selectedReportResponseId = '';
    this.reportResponseData = {};
  }

  getReportResponse(periodId: String, userId: String) {
    this.reportResponseData = {}
    this.reportResponseService.get(periodId, userId).subscribe({
      next: (response: any) => {
        if (response.length > 0) {
          this.selectedReportResponseId = response[0]._id
          this.reportResponseData = response[0]
          this.loadConceptResponses();
        }

      }, error: (err) => {
        Swal.fire('Error', 'Ocurrió un error al obtener el reporte', 'error');
        console.error('Error obteniendo reportes:', err);
      }
    })
  }

  loadConceptResponses(): void {
    Swal.fire({
      title: 'Cargando reporte...',
      html: 'Por favor espera',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.conceptResponseService.getView(this.selectedReportResponseId).subscribe((data: any) => {
      if (data.length === 0) {
        Swal.fire('Sin resultados', 'No se encontraron conceptos para este reporte', 'info');
        this.concepts = [];
        return;
      }
      this.concepts = data;
    });
    Swal.close()
  }

  onEditConcept(concept: any) {
    let data = {
      employeeConceptId: concept.employeeConceptId,
      reportResponseId: concept.reportResponseId,
      conceptResponseId: concept._id
    }
    this.reportResponseService.setDataToEdit(data)
  }

  onDeleteConcept(concept: any) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción eliminará la respuesta al concepto permanentemente.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.searchExpensesAndDelete(concept._id)
      }
    });
  }

  deleteConceptResponse(conceptResponseId: string) {
    this.conceptResponseService.delete(conceptResponseId).subscribe(data => {
      if (data) {
        Swal.fire('Éxito', 'Se ha eliminado el concepto', 'success')
        this.loadConceptResponses()
      }
    })

  }

  deleteExpenses(conceptResponseId: string) {
    this.expenseService.deleteAllByConceptResponseId(conceptResponseId).subscribe(data => {
      if (data) {
        Swal.fire('Éxito', 'Se han eliminado los gastos', 'success')
        this.deleteConceptResponse(conceptResponseId)
      } else {
        Swal.fire('Error', 'NO se han eliminado los gastos', 'error')

      }
    })

  }

  deleteAttachments(expenseId: any) {
    //necesitamos el expenseId para poder eliminar todos los archivos de una vez
    this.expenseAttachmentsService.deleteAllByExpenseId(expenseId).subscribe(data => {
      if (data) {
/*         Swal.fire('Éxito', 'Se han eliminado los adjuntos del gasto', 'success')
 */      }
    })

  }

  searchExpensesAndDelete(conceptResponseId: string): void {
    this.expenseService.get(conceptResponseId).subscribe(data => {
      if (data) {
        if (data.length > 0) {
          const ids = data.map((expense: any) => expense._id);

          ids.forEach(id => {
            this.deleteAttachments(id);
          });
        }
        this.deleteExpenses(conceptResponseId)
        /*         Swal.fire('Éxito', 'Se han eliminado los adjuntos de todos los gastos asociados', 'success');
         */
      } else {
        Swal.fire('Sin resultados', 'No se encontraron gastos para este concepto', 'info');
      }
    }, error => {
      console.error('Error al buscar gastos:', error);
      Swal.fire('Error', 'No se pudo obtener la lista de gastos', 'error');
    });
  }

  openFilesModal(conceptData: any) {
    this.expenseAttachmentsService.getView(conceptData._id).subscribe(data => {
      if (data) {
        if (data.length === 0) {
          Swal.fire('Sin resultados', 'No se encontraron archivos adjuntos para este concepto', 'info');
          this.attachments = [];
          return;
        }
        this.attachments = data;
        //abrir modal de lista de archivos adjuntos
        this.openListAttachmentsModal();
      } else {
        Swal.fire('Sin resultados', 'No se encontraron archivos adjuntos para este concepto', 'info');
      }
    }, error => {
      console.error('Error al buscar archivos adjuntos:', error);
      Swal.fire('Error', 'No se pudo obtener la lista de archivos adjuntos', 'error');
    });

  }

  onOpenAttachment(attachementId: any) {
    this.expenseAttachmentsService.setCurrentAttachmentId(attachementId)
    setTimeout(() => {
      this.openAttachmentViewerModal();
    }, 1500)
  }

  onApproveConcept(concept: any) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción marcará el concepto como correcto',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, aprobar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.conceptResponseService.approve(concept._id).subscribe(data => {
          if (data) {
            Swal.fire('Éxito', 'Se ha aprobado el concepto', 'success')
            this.loadConceptResponses()
          }
        })
      }
    });
  }

  onRejectConcept(concept: any) {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción marcará el concepto como incorrecto',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, rechazar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.conceptResponseService.reject(concept._id).subscribe(data => {
          if (data) {
            Swal.fire('Éxito', 'Se ha rechazado el concepto', 'success')
            this.loadConceptResponses()
          }
        })
      }
    });
  }

}

